import { LoadableRoute } from 'routes/utils/loadable';

export const OnboardingContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "Onboarding" */ './Onboarding'),
});
